<template lang="pug">

router-view

</template>

<script>
import './blocks/loading.vue'

export default {
  name: 'Single',
}
</script>

<style lang="sass" scoped></style>
